export enum BroadcastMessageType {
  CHAT_NEW_MESSAGE = 'CHAT_NEW_MESSAGE',
  CHAT_MESSAGE_STATUS = 'CHAT_MESSAGE_STATUS',
  CHAT_TYPING = 'CHAT_TYPING',
  CHAT_PRESENCE = 'CHAT_PRESENCE',
  CHAT_UNREAD_COUNT = 'CHAT_UNREAD_COUNT',
  NOTIFICATION_NEW = 'NOTIFICATION_NEW',
  NOTIFICATION_COUNT_UPDATE = 'NOTIFICATION_COUNT_UPDATE',
  APPROVAL_NEW = 'APPROVAL_NEW',
  APPROVAL_COUNT_UPDATE = 'APPROVAL_COUNT_UPDATE',
  TASK_UPDATE = 'TASK_UPDATE',
  TAB_BECAME_LEADER = 'TAB_BECAME_LEADER',
  TAB_PING = 'TAB_PING',
  TAB_PONG = 'TAB_PONG',
}

export enum WebSocketMessageType {
  WS_CHAT_MESSAGE = 'WS_CHAT_MESSAGE',
  WS_MESSAGE_STATUS = 'WS_MESSAGE_STATUS',
  WS_PRESENCE_UPDATE = 'WS_PRESENCE_UPDATE',
  WS_TYPING_INDICATOR = 'WS_TYPING_INDICATOR',
  WS_ERROR = 'WS_ERROR',
  WS_NOTIFICATIONS = 'WS_NOTIFICATIONS',
  WS_APPROVALS = 'WS_APPROVALS',
  WS_TASKS = 'WS_TASKS',
  WS_TASK_PROGRESS = 'WS_TASK_PROGRESS',
  WS_CHAT_UNREAD = 'WS_CHAT_UNREAD',
  WS_COUNTS = 'WS_COUNTS',
  WS_CONNECTED = 'WS_CONNECTED',
  WS_DISCONNECTED = 'WS_DISCONNECTED',
  WS_SEND_MESSAGE = 'WS_SEND_MESSAGE',
  WS_SEND_TYPING = 'WS_SEND_TYPING',
  WS_SEND_READ_RECEIPT = 'WS_SEND_READ_RECEIPT',
  WS_SEND_DELIVERY_RECEIPT = 'WS_SEND_DELIVERY_RECEIPT',
  WS_SUBSCRIBE_TYPING = 'WS_SUBSCRIBE_TYPING',
  WS_UNSUBSCRIBE_TYPING = 'WS_UNSUBSCRIBE_TYPING',
}

export enum AuthScreenType {
  SignIn, ForgotPassword, OTPCheck, ChangePassword, LoggedIn
}

export enum FromGridAction {
  Yes, No
}

export enum AddIsNullIfNeeded
{
  Yes, No
}

export enum AgCellDataTypes {
  TEXT = "text",
  NUMBER = "number",
  BOOLEAN = "boolean",
  DATE = "date",
  DATE_STRING = "dateString",
  DATE_TIME = "dateTime",
  DATE_TIME_STRING = "dateTimeString",
  OBJECT = "object"
}


export enum EditScreenGridToolbarFunction {
  AddNewLine = "addNewLine",
  CopyLine = "copyLine",
  MultiCopy = "multiCopy",
  DeleteLine = "deleteLine",
  GoToLine = "goToLine",
  AutoFitCols = "autoFitCols",
  AutoFitColumns = "autoFitColumns",
  RowDrag = "rowDrag",
  ColumnsDrag = "columnsDrag",
  ViewSortedColumns = "viewSortedColumns",
  findTextLocally = "findTextLocally",
  removeFilter = "removeFilter",
}

export enum TooltipContext {
  EditView = 'EditView',
  ListView = 'ListView',
  Searcher = 'Searcher',
}
